import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";
import "./styles/global.css";

const root = document.querySelector<HTMLDivElement>("#root");

if (!root) {
  throw new Error("The Reelio app root is missing.");
}

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
